export default "__VITE_ASSET__Bl9RIeGg__"